import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch'
import { environment } from '../../../../environments/environment';
import { ONBOARD_CONSTANTS } from '../../../app.constants';
import { UpdateEmailRequestModel } from './cart.model';
import { AppService } from '../../../app.service';
import { BuywifiService } from '../../../services/buywifi.service';
import { HttpService } from '../../../services/http.service';
import { ErrorService } from '../../error/error.service';
import { TravelersService } from '../../travelers/travelers.service';
import { TravellersService } from '../../travelers/travellers.service';
import { APP_TRANSLATE } from '../../../app.translation.en';
import { PassengerRequestModel } from '../../travelers/travellers.model';

declare let $: any;
@Injectable()
export class CartService {
  loaderTextList = { loaderHeaderText: APP_TRANSLATE.loaderText, loaderSubHeaderText: '' };
  constructor(private buywifiService: BuywifiService, private httpService: HttpService, private travelersService: TravelersService, private travellersService: TravellersService,
    private appService: AppService, private errorService: ErrorService) { }

  updateEmailRequest(email: string, passengerId: string): UpdateEmailRequestModel {
    const reservationId = this.buywifiService.getPassengerResponse().reservationInfo.reservationId;
    const updateEmailRequest = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.RESERVATION_UPDATE_CONTACTINFO_URL.replace('RESERVATION_ID', reservationId),
      data: {
        'contactInformationPerPassenger': [{
          'id': passengerId,
          'email': email
        }]
      }
    }
    return updateEmailRequest;
  }

  doUpdateEmailCall(email: string, passengerId: string): Observable<any> {
    const updateCallRequest = this.updateEmailRequest(email, passengerId);
    return this.httpService.postData(updateCallRequest).map(
      updateEmailResponse => {        
        return updateEmailResponse;
      },
      (error: any) => {
        this.errorService.addError(this.buywifiService.getDefaultError());
        this.appService.hideLoaderWithText();
      }
    );
  }

  updatedEmailInPaxResponse(updatedEmail) {
    const passengerResponse = this.buywifiService.getPassengerResponse();
    if (passengerResponse) {
      passengerResponse.reservationInfo.emailAddress = updatedEmail;
      this.buywifiService.setPassengerResponse(passengerResponse);
    }
  }

  getPassengerRequestEntityUsingEmail(email): PassengerRequestModel {
    const passengerResponse = this.buywifiService.getPassengerResponse();
    const deviceDetails = this.appService.getDeviceResponse();
    const pnr = passengerResponse.bookingReference;
    const fN = passengerResponse.firstName;
    const lN = passengerResponse.lastName;
    const request = ONBOARD_CONSTANTS.GET_PASSENGER.replace('<<pnr>>', pnr).replace('<<fn>>', fN).replace('<<ln>>', lN);
    const formPassengerRequest = `${request}&flightId=${deviceDetails.flightId}&emailId=${email}`;
    const getPassengerRequest = {
      url: environment.apiBaseUrl + formPassengerRequest,
      headers: { 'Accept-Language': `${this.appService.getLanguage()}_${this.appService.getPOS()}` }
    };
    return getPassengerRequest;
  }


  initiateReserveRequest(sessionValue: any) {
    const passengerResponse = this.buywifiService.getPassengerResponse();
    const offersResponse = this.buywifiService.getOffersResponse();
    const passengerId = passengerResponse.reservationInfo.reservationPassengerId;
    const productIdentifier = this.buywifiService.getProductId();
    const reserveRequest = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.INITIATE_RESERVE_URL,
      data: {
        'offerId': offersResponse.offerId,
        'instantReserve': true,
        'products': {
          'wifi': [
            {
              'productId': productIdentifier,
              'quantity': sessionValue
            }
          ]
        }
      },
      headers: { 'Accept-Language': `${this.appService.getLanguage()}_${this.appService.getPOS()}` }
    }
    const old = JSON.stringify(reserveRequest).replace('PASSENGERID', passengerId); // convert to JSON string    
    return JSON.parse(old);
  }

  initiateCharterRequest(sessionValue) {
    let passengerResponse;
    passengerResponse = this.travelersService.getCharterFormData();
    if (this.appService.isUnconfirmedTicket) {
      passengerResponse = this.travelersService.getPnrFormData();
      passengerResponse['email'] = this.travellersService.passengerResponseReceived.reservationInfo.emailAddress;
    }
    const offersResponse = this.buywifiService.getOffersResponse();
    const productIdentifier = this.buywifiService.getProductId();
    const reserveRequest = {
      url: environment.apiBaseUrl + ONBOARD_CONSTANTS.INITIATE_RESERVE_URL,
      data: {
        'offerId': offersResponse.offerId,
        'instantReserve': true,
        'firstName': passengerResponse.firstname,
        'lastName': passengerResponse.secondname,
        'emailId': passengerResponse.email,
        'context': 'ONC',
        'products': {
          'wifi': [
            {
              'productId': productIdentifier,
              'quantity': sessionValue
            }
          ]
        }
      },
      headers: { 'Accept-Language': `${this.appService.getLanguage()}_${this.appService.getPOS()}` }
    }
    const old = JSON.stringify(reserveRequest); // convert to JSON string    
    return JSON.parse(old);
  }


  initiateReserveCall(sessionValue: number) {
    this.appService.removePositionValue();
    let reserveCallRequest;
    if (this.appService.isCharter || this.appService.isUnconfirmedTicket) {
      reserveCallRequest = this.initiateCharterRequest(sessionValue);
    } else {
      reserveCallRequest = this.initiateReserveRequest(sessionValue);
    }
    return this.httpService.postData(reserveCallRequest).map(
      reserveCallResponse => {
        this.appService.hideLoaderWithText();
        return reserveCallResponse;
      },
      (error: any) => {
        this.errorService.addError(this.buywifiService.getDefaultError());
        this.appService.hideLoaderWithText();
        return error;
      }
    );
  }

  releaseCallRequest(checkoutId: string) {
    const checkoutUrl = ONBOARD_CONSTANTS.RELEASE_URL.replace('<<CHECKOUTID>>', checkoutId);
    const saveCardRequest = {
      url: environment.apiBaseUrl + checkoutUrl,
      data: {
        'reason': 'FUNBACK'
      },
      headers: { 'Accept-Language': `${this.appService.getLanguage()}_${this.appService.getPOS()}` }
    }
    return saveCardRequest;
  }

  doReleaseCall(checkoutId: string) {
    const releaseCallRequest = this.releaseCallRequest(checkoutId);
    return this.httpService.postData(releaseCallRequest).map(
      releaseCallResponse => {
        return releaseCallResponse;
      },
      (error: any) => {
        this.appService.hideLoaderWithText();
        return error;
      }
    );
  }
  closeOverlayWhenInitiateFailed() {
    $('#wifi-onboard-email-overlay').css('display', 'none');
  }

}
